export default "__VITE_ASSET__h5MsOW9S__"